import {createSlice} from "@reduxjs/toolkit";
import {setMeterFlowVolumeReviewPageFilter} from "./actions";
import {MeterFlowVolumeTotalSearchCriteria} from "@ots-frontend/ots-data";

type VolumeInventorySearchPageState = {
  filter?: MeterFlowVolumeTotalSearchCriteria
}

const INITIAL_STATE: Readonly<VolumeInventorySearchPageState> = {
  filter: undefined,
};

const meterFlowVolumeReviewPageUISlice = createSlice({
  name: "ots-ui/volume-inventory-search-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setMeterFlowVolumeReviewPageFilter,
      (state, {payload}) => {
        state.filter = payload
      }
    );
  }
});

export const meterFlowVolumeReviewPageUIReducer = meterFlowVolumeReviewPageUISlice.reducer;
